import i18n from "i18next";
import { useGenericDialog } from "src/components/common/dialogs/GenericDialogContext.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";
import { CustomerOfferLinePropertyModelSubConfigurationImportView } from "src/components/views/erp/configurator/configuratorForm/impl/CustomerOfferLinePropertyModelSubConfigurationImportView.tsx";
import { PropertyModelSubConfigurationImportAction } from "src/components/views/erp/configurator/configuratorForm/propertyModel/propertyModelSubConfigurationImport.ts";

/** Imports sub-configurations of the property-model form from other lines of the offer. */
export function useCustomerOfferLinePropertyModelSubConfigurationImportAction({
	customerOfferId,
	currentCustomerOfferLineId,
}: {
	customerOfferId: number;
	currentCustomerOfferLineId?: number;
}): PropertyModelSubConfigurationImportAction {
	const { openDialog } = useGenericDialog();
	const title = i18n.t("import_from_another_offer_line");

	return {
		title: title,
		onClick: async ({ targetSchema, targetProperties, targetLabel, importChildren }) => {
			openDialog(({ closeDialog }) => ({
				title: title,
				size: "xl",
				content: (
					<CustomerOfferLinePropertyModelSubConfigurationImportView
						customerOfferId={customerOfferId}
						currentCustomerOfferLineId={currentCustomerOfferLineId}
						targetSchema={targetSchema}
						targetProperties={targetProperties}
						closeDialog={closeDialog}
						onSubmit={async (children) => {
							await closeDialog();
							await importChildren(children);
						}}
					/>
				),
				agentContext: {
					key: defineAgentUiContextKey(
						"erp.configurator.importPropertyModelSubConfigurationFromOfferLine.dialog",
					),
					title: title,
					pathSegments: [targetLabel],
					data: {
						customerOfferId: customerOfferId,
						currentCustomerOfferLineId: currentCustomerOfferLineId ?? null,
						targetPropertyNames: targetProperties.map((property) => property.name),
					},
				},
			}));
		},
	};
}
